<template>
  <div id="app">
    <header class="header">
      <section class="container">
        <div class="logo">
          <div @click="toPage(0)" style="display: flex; align-items: center; justify-content: center">
            <img src="@/assets/images/s3.png" alt="" style="width: 70px; height: 40px; display: inline-block" />
            <span style="padding-left: 8px">苏恩随笔 sunnit</span>
          </div>
          <i class="iconfont icon-shezhigengduo menu" v-if="!showTopNav" @click.stop="showTopNav = true"></i>
          <i class="iconfont icon-guanbixiao menu" v-else @click.stop="showTopNav = false"></i>
        </div>
        <ul class="nav-top" v-if="showTopNav">
          <li v-for="(nav, index) in navList" :key="index" :class="$route.path === nav.url ? 'nav-item nav-active' : 'nav-item'
            " @click="toPage(index)">
            <i class="iconfont" :class="nav.icon"></i>
            <span>{{ nav.name }}</span>
          </li>
          <li class="nav-item search">
            <input type="text" placeholder="这里有你想要" v-model.trim="title" @keydown.enter.prevent="getBlogList" />
            <span class="iconfont icon-sousuo1" @click.stop="getBlogList"></span>
          </li>
        </ul>
      </section>
    </header>
    <div id="app-wrap">
      <div class="flex container">
        <!-- 侧边栏 -->
        <nav>
          <ul class="nav-left">
            <template v-for="(nav, index) in navList">
              <li v-if="nav.show" :key="index" :class="$route.path === nav.url ? 'nav-item nav-active' : 'nav-item'
                " @click="toPage(index)">
                <i class="iconfont" :class="nav.icon"></i>
                <span>{{ nav.name }}</span>
              </li>
            </template>
          </ul>
        </nav>

        <!-- 路由占位符 -->
        <main class="main">
          <router-view></router-view>
        </main>

        <!-- 右侧信息 -->
        <aside class="aside">
          <!-- 搜索框 -->
          <div class="white-card">
            <div class="search input-wrap">
              <input type="text" placeholder="这里有你想要" v-model.trim="title" @keydown.enter.prevent="getBlogList" />
              <span class="iconfont icon-sousuo1" @click.stop="getBlogList"></span>
            </div>
            <!-- 搜索到的文章 -->
            <!-- <div id="search-result" v-if="showResult">
              <div
                class="white-card"
                style="box-shadow: 0 0 6px rgba(0, 0, 0, 0.2)"
              >
                <h4>猜您想要</h4>
                <ul v-if="list.length">
                  <li
                    v-for="(item, index) in list"
                    :key="item.blogId"
                    @click.stop="toDetail(item.blogId)"
                  >
                    <span>{{ index + 1 }}. {{ item.title }}</span>
                  </li>
                </ul>
                <div v-else class="no-data">哦豁~没有找到您要的数据!</div>
                <ul>
                  <li
                    style="text-align: center; border: none"
                    @click.stop="clearResult"
                  >
                    <span
                      >收起结果<i class="iconfont icon-xiangshang"></i
                    ></span>
                  </li>
                </ul>
              </div>
            </div> -->
          </div>

          <!-- 联系方式 -->
          <contact ref="contact"></contact>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
import contact from "@/views/contact/index.vue";
export default {
  name: "app",
  data() {
    return {
      navList: [
        {
          name: "首页",
          icon: "icon-zhuye",
          url: "/index",
          show: true,
        },
        {
          name: "随笔",
          icon: "icon-shuji1",
          url: "/blogs",
          show: true,
        },
        {
          name: "经典",
          icon: "icon-huo",
          url: "/assemble",
          show: true,
        },
        {
          name: "投稿",
          icon: "icon-lijitoudi",
          url: "/contribute",
          show: true,
        },
        {
          name: "联系",
          icon: "icon-dianhua",
          url: "/contact",
          show: false,
        },
      ],
      navIdx: 0,
      path: "", //记录网址
      title: "", //模糊查询标题
      list: [], //模糊查询得到的结果
      showResult: false, //显示结果
      showTopNav: false, //展示顶部导航栏
    };
  },
  created() { },
  components: {
    contact,
  },
  watch: {
    "$route.path": {
      async handler(val) {
        if (this.path === val) return;
        this.path = val;
        this.$refs["contact"].getStatis();
        await this.visit(val);
        window.scrollTo({ top: 0, behavior: "smooth" }); //滚动到顶部
      },
      deep: true,
    },
  },
  methods: {
    //前往文章详情
    toDetail(id) {
      this.$router.push({
        path: "/detail",
        query: {
          blogId: id,
        },
      });
    },

    //清除结果
    // clearResult() {
    //   this.showResult = false;
    //   this.title = "";
    //   this.list = [];
    // },

    //获取随笔列表
    getBlogList() {
      if (!this.title) {
        return alert("请先输入关键字");
      }
      if (this.title === this.$route.query.title) return;
      this.$router.push({
        path: "/search",
        query: {
          title: this.title,
        },
      });
      this.title = "";
      this.showTopNav = false;
      // const { API, $request, title } = this;
      // if (!title) return alert("请先输入随笔标题!");
      // const url = API.getBlogList;
      // const { data: res } = await $request(url, "get", {
      //   title,
      //   status: "0",
      // });
      // this.list = res.data || [];
      // this.showResult = true;
    },

    //导航功能
    toPage(idx) {
      const { navList } = this;
      if (this.$route.path === navList[idx].url) return;
      this.navIdx == idx;
      this.$router.push(navList[idx].url);
      this.showTopNav = false;
    },

    //访问增加记录
    async visit(page) {
      const { $request, API } = this;
      const url = API.visit;
      const { data: res } = await $request(
        url,
        "post",
        {
          visitPage: page,
        },
        {
          "Content-Type": "application/x-www-form-urlencoded",
        }
      );
    },
  },
};
</script>
<style src="./assets/iconfont/iconfont.css"></style>
<style src="./assets/css/common.css"></style>
<style src="@wangeditor/editor/dist/css/style.css"></style>
